import React, { memo } from 'react';
import { ButtonGroup, MainHeader, HeaderText } from '../Shared/components';
import {
  HeroContainer,
  LegalContainer,
  StyledLegalText,
  SubheaderText,
} from './components';
import { textClass } from '@spotify-internal/encore-web/core';
import Button from '../Shared/Button';
import Container from '../Shared/Container';
import {
  eventParamAttributes,
  EventParamTypes,
  inViewEventAttributes,
} from '@spotify-internal/touchdown-analytics';
import { purify } from '../../lib/purify';

type HeroType = {
  container?: React.ComponentProps<typeof Container>;
  header?: { text: string };
  subheaders?: { text: string }[];
  buttons?: React.ComponentProps<typeof Button>[];
  legalDisclaimer?: string;
  textColor?: string;
  eventParams?: EventParamTypes;
  label?: { text: string };
};

export function Hero(props: HeroType) {
  const {
    container,
    header,
    subheaders,
    buttons,
    legalDisclaimer,
    eventParams,
  } = props;

  const renderButton = (
    button: React.ComponentProps<typeof Button>,
    index: number,
  ) => {
    return <Button key={`button-${index}`} {...button} />;
  };

  return (
    <HeroContainer
      {...container}
      {...eventParamAttributes({ ...eventParams, componentType: 'promo' })}
      {...inViewEventAttributes()}
    >
      <MainHeader>
        {header && (
          <div>
            <HeaderText
              as="h1"
              className={textClass('headlineMedium')}
              dangerouslySetInnerHTML={{
                __html: purify(header.text),
              }}
            />
          </div>
        )}
        {subheaders &&
          subheaders.map((subheader, index) => (
            <div key={`subheader-${index}`}>
              <SubheaderText
                as="h2"
                dangerouslySetInnerHTML={{
                  __html: purify(subheader.text),
                }}
              />
            </div>
          ))}
      </MainHeader>
      {buttons && (
        <ButtonGroup>
          {buttons.map((button, index) => renderButton(button, index))}
        </ButtonGroup>
      )}
      {legalDisclaimer && (
        <LegalContainer>
          <StyledLegalText text={legalDisclaimer} />
        </LegalContainer>
      )}
    </HeroContainer>
  );
}

export default memo(Hero);
